<template>
  <div style="z-index: 1">
    <svg
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="100%"
      height="100%"
      viewBox="0 0 120 24"
      preserveAspectRatio="none"
    >
      <title>{{ hint }}</title>
      <defs>
        <linearGradient
          id="ph-KeyGradient"
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="0"
          x2="0"
          y2="24"
        >
          <stop style="stop-opacity: 1; stop-color: #99A1AF" offset="0" />
          <stop style="stop-opacity: 1; stop-color: #e3e2e2" offset="0.50" />
          <stop style="stop-opacity: 1; stop-color: #99A1AF" offset="1" />
        </linearGradient>
        <linearGradient
          id="ph-OilGradient"
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="0"
          x2="0"
          y2="24"
        >              
        <!--https://tailwindcss.com/docs/colors gray-->
          <stop style="stop-opacity: 1; stop-color: #868485 " offset="0" />
          <stop style="stop-opacity: 1; stop-color: #99A1AF" offset="0.5" />
          <stop style="stop-opacity: 1; stop-color: #868485 " offset="1" />
        </linearGradient>
        <rect id="ph-main" x="0" y="0" width="120" height="24"></rect>
      </defs>
      <g :visibility="fState[0]">
        <use href="#ph-main" fill="url(#ph-KeyGradient)" />
      </g>
      <g :visibility="fState[1]">
        <use href="#ph-main" fill="url(#ph-OilGradient)" />
      </g>
      <g :visibility="fState[2]">
        <use href="#ph-main" fill="url(#ph-KeyGradient)" />
      </g>
      <g :visibility="fState[3]">
        <use href="#ph-main" fill="url(#ph-KeyGradient)" />
      </g>
      <g :visibility="fState[4]">
        <use href="#ph-main" fill="url(#ph-KeyGradient)" />
      </g>
      <g :visibility="fState[5]">
        <use href="#ph-main" fill="url(#ph-KeyGradient)" />
      </g>
      <g :visibility="fState[10]">
        <use href="#ph-main" fill="url(#ph-KeyGradient)" />
      </g>
    </svg>
  </div>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "pipeline_horizontal",
  mixins: [MixinStates],
};
</script>
